<div [ngClass]="{'product-item-inner-featured': isFeatured, 
                  'product-item-inner': !isFeatured}">
    <a [routerLink]="[routerLinkUrl]" [queryParams]="{itm: product?.id}">
        <div class="product-thumb">
            <img *ngIf="primaryImage" [attr.src]="primaryImage"
                style="max-width: 100%;max-height: 100%" onError="this.src='assets/images/img-not-available.png';"
                class="image-center">
            <!-- <img src="assets/images/24-delivery.png" class="delivery-banner"> -->
        </div>
    </a>
    <div class="product-caption">
        <div class="row product-caption--details">
            <div class="product-name">
                <a routerLink="./itm{{product?.product_url}}" [queryParams]="{itm: product?.id}">{{product?.name}}</a>
            </div>
            <div class="rating">
                <bar-rating [rate]="product?.ratingInfo?.rating" [theme]="'default'" 
                    (rateChange)="updateRating($event)"></bar-rating>
            </div>
        </div>
        <div class="row">
            <div class="col-8 text-concat">
                <span
                    [ngClass]="{'pdp-danger-font': productQuantity?.quantityLow, 'pdp-green-font': !productQuantity?.quantityLow}">
                    {{productQuantity?.availabilityMessage}} </span>
            </div>
            <div class="col-4 text-concat">
                <div class="sale-percentage" *ngIf="product?.sale_price_percentage"> - {{product?.sale_price_percentage}}
                    % </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <ng-container *ngIf="company && !company?.allCompanySettings?.shopPriceWithTax">
                    <ng-container *ngIf="product?.sale_price_without_tax">
                        <span class="price-new">
                            {{product?.sale_price_without_tax?.amount | currency:product?.sale_price_without_tax?.currency:'symbol' : '1.0-2'}}
                            <del>{{product.priceWithoutTax?.amount | currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2'}}</del>
                        </span>
                        <div class="product-tax">+
                            {{ product?.taxRate?.rate }}% <span i18n="@@Pdv">PDV</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!product?.sale_price_without_tax">
                        <span class="price-new">
                            {{product?.priceWithoutTax?.amount | currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2' }}
                        </span>
                        <div class="product-tax">+
                            {{ product?.taxRate?.rate }}% <span i18n="@@Pdv">PDV</span>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="company && company?.allCompanySettings?.shopPriceWithTax">
                    <ng-container *ngIf="product?.sale_price_without_tax">
                        <span class="price-new">
                            {{ (product?.sale_price_without_tax?.amount  * ((product?.taxRate?.rate / 100) + 1))  | currency:product?.sale_price_without_tax?.currency:'symbol' : '1.0-2' }}
                        </span>
                        <del>{{(product.priceWithoutTax?.amount  * ((product?.taxRate?.rate / 100) + 1)) | currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2'}}</del>

                    </ng-container>
                    <ng-container *ngIf="!product?.sale_price_without_tax">
                        <span class="price-new">
                            {{  (product?.priceWithoutTax?.amount * ((product?.taxRate?.rate / 100) + 1))  | currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2'}}
                        </span>
                    </ng-container>
                </ng-container>

                <!-- 
                <span [ngClass]="{ 'price-old ': product?.sale_price_without_tax, 'price-new': !product?.sale_price_without_tax}" class="float-left">{{product?.priceWithoutTax?.amount | number : '1.2-2' }} rsd</span>
                <span *ngIf="product?.sale_price_without_tax" class="float-left price-new margin-left-10">{{product?.sale_price_without_tax?.amount | number : '1.2-2' }} rsd</span> -->
            </div>
        </div>
    </div>
</div>